import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { modalClose, modalOpen } from '../../../../layout/redux/layoutActions'
import { Button, Modal, Select } from '../../../../components'
import { history, IF, numberAleatori } from '../../../../helpers'
import { estabelecimentosVerificar, listarEstabelecimentosVerificar, putListMeuProjetoTab, setListMeuProjetoTab } from '../../redux/meusProjetosActions'


export default ({data}) => {
  const dispatch = useDispatch()
  const {idProjetos, idPasso} = useParams()
  const { sistema, statusModal } = useSelector(state => state.layoutState)
  const { meuProjeto } = useSelector(state=> state.meusProjetosState)
  const nls = require(`../../nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

  const [form, setForm] = useState({})

  useEffect(()=> {
    if (meuProjeto.estabelcimentosVerificar.length) {
      setForm(meuProjeto.estabelcimentosVerificar[0])
    }
  }, [meuProjeto.estabelcimentosVerificar])


  const handlerCriarOLD = e => {
    console.log("ENTROU EM VERIFICAR.JS")
    dispatch(estabelecimentosVerificar({IdItemVerificacao: e.idLojaRetorno, IdEstabelecimento: data.idEstabelecimento, idProjetos, nlsPopup}))      
    handleCloseModal()
  }  


const handlerCriar = (e) => {
  dispatch(estabelecimentosVerificar({
    IdItemVerificacao: e.idLojaRetorno,
    IdEstabelecimento: data.idEstabelecimento,
    idProjetos,
    nlsPopup
  }))
  .then((success) => {
    if (success) {
      handleCloseModal();
    }
  })
  .catch(error => {
    console.error("Erro na verificação:", error);
  });
};



  const handleCloseModal = e => {
    dispatch(modalClose()) 
  }
  
  return (
    <Modal
      title={nls.configurar?.verificarEstabelecimentoTitle}
      size='medium'
      open={statusModal === 'verificarEstabelecimentosMeuProjeto' ? true : false}
      close={() => dispatch(modalClose())}
      closeText={nls.criarProjeto?.btnFechar}
      actions={<>
      <IF se={meuProjeto.estabelcimentosVerificar.length}>
        <Button
          color='primary'
          onClick={()=> meuProjeto.estabelcimentosVerificar.length ? 
              handlerCriar(form)
            : null
          }
        >{nls.configurar?.btnSalvarEstabelecimento}</Button>
      </IF>
      </>}
    >
      <div className='modal-meuProjeto-estabelecimentos-verificar'>
        <p className='informe'>{nls.configurar?.informeClick}</p>
        <div>
          {meuProjeto.estabelcimentosVerificar.length ? meuProjeto.estabelcimentosVerificar?.map(e=> {
            return <div key={e.idLojaRetorno} onClick={()=> setForm(e)} className={e.idLojaRetorno === form.idLojaRetorno ? 'select-endereco active' : 'select-endereco'}>
              <label>{e.endereco} - {e.cidade}</label>
              <span>{e.descricao}</span>
            </div>
          }) : <p className='sem-itens'>{nls.naoEncontrado}</p>}
        </div>
      </div>
    </Modal>
  )
}